export enum VideoType {
  VIDEO = 'Video',
  AUDIO = 'Audio',
}

export interface Video {
  id: number;
  name: string;
  length: number;
  mediaSource: string;
  type: VideoType;
}

export interface VideosNormalized { [id: string]: Video }

export interface JwPlayerVideo extends Video {
  hasBeenTranscoded: string;
  originalUrl: string;
  videoPlayerUrl: string;
  downloadLink: string;
  canDownload: boolean;
  lowestAvailableQualityUrl: string;
  highQualityUrl: string;
  mediumQualityUrl: string;
  lowQualityUrl: string;
  thumbnailUrl: string;
  highQualityThumbnailUrl: string;
  numCoursesUsing: boolean;
  lowDefaultPlayback: boolean;
  mediumDefaultPlayback: boolean;
  highDefaultPlayback: boolean;
  transcriptUrl: string;
  downloadUrl: string;
  url: string;
}
